import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  QueryKeys,
  useAppLocation,
  useAppState,
  useAppTranslation,
} from "../../../common";
import { ErrorModal, Modal } from "../../../components";
import { deleteAchievementAction } from "../../../actions";

type AchievementDeleteModalProps = {
  handleDeleteModalVisible: () => void;
};

export function AchievementDeleteModal(props: AchievementDeleteModalProps) {
  const { t } = useAppTranslation();
  const location = useAppLocation();

  const queryClient = useQueryClient();
  const [state, setState] = useAppState({
    errorModalVisible: false,
  });

  const handleModalVisibility = () => {
    setState((prevState) => ({
      ...prevState,
      errorModalVisible: !prevState.errorModalVisible,
    }));
  };

  const deleteAchievement = useMutation({
    mutationKey: [QueryKeys.deleteAchievementQuery],
    mutationFn: deleteAchievementAction,
    onSuccess() {
      props.handleDeleteModalVisible();
      queryClient.invalidateQueries({ queryKey: [QueryKeys.achievementQuery] });
    },
    onError() {
      handleModalVisibility();
    },
  });

  const handleDeleteAchievement = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    deleteAchievement.mutate({ id: location.state?.id });
  };

  return (
    <div>
      <section>
        <Modal
          onClose={props.handleDeleteModalVisible}
          title={t("achievement-page-delete-modal-title")}
          footer
          submitText={t("achievement-page-delete-submit-button-title")}
          cancelText={t("achievement-page-delete-cancel-button-title")}
          handleSubmit={handleDeleteAchievement}
          loading={deleteAchievement.isPending}
        >
          <span>{t("achievement-page-delete-achievement-question-label")}</span>
        </Modal>
      </section>
      <section>
        {state.errorModalVisible && (
          <ErrorModal
            error={deleteAchievement.error}
            onClose={handleModalVisibility}
            title={t("achievement-page-delete-achievement-error-modal-title")}
          />
        )}
      </section>
    </div>
  );
}
